import { render, staticRenderFns } from "./clienti.html?vue&type=template&id=977321e4&scoped=true&"
import script from "./Clienti.vue?vue&type=script&lang=js&"
export * from "./Clienti.vue?vue&type=script&lang=js&"
import style0 from "./Clienti.vue?vue&type=style&index=0&id=977321e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "977321e4",
  null
  
)

export default component.exports